import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// component

// store
import { styled } from "@material-ui/styles";
import { StoreContext } from "../../../../../../store/StoreProvider";
import Act from "../../../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../../../config/CONSTANTS";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import urls from "../../../../../../api/project/ApiUrls";
import featureDisplay from "../../../../../../common/utils/featureDisplay";

// style

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiTabs-indicator": {
    backgroundColor: "#121212",
  },
}));

const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .Mui-selected": {
    color: "#121212",
  },
}));

const CustomTabs = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [curTabIdx, setCurTabIdx] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const tabsInfo = [
    { name: ROUTE_NAME.Sna, path: ROUTE_PATH.Sna },
    { name: ROUTE_NAME.Gis, path: ROUTE_PATH.Gis },
  ];

  const handleChange = (event, newValue) => {
    setCurTabIdx(newValue);
    const findTab = tabsInfo[newValue];
    if (findTab) {
      navigate(handleLocaleRoute(findTab.path));
    }
  };

  return (
    <Box display="inline-block">
      <StyledTabs
        value={curTabIdx}
        textColor="inherit"
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        {[
          {
            label: intl.formatMessage({
              id: "snaPage.tabs.sna",
              defaultMessage: "網絡圖",
            }),
            index: 0,
            public: true,
          },
          {
            label: intl.formatMessage({
              id: "snaPage.tabs.gis",
              defaultMessage: "地理資訊",
            }),
            index: 1,
            public: featureDisplay(process.env.REACT_APP_GIS_PUBLIC),
          },
        ]
          .filter((item) => item.public)
          .map((item, idx) => (
            <StyledTab
              key={idx.toString()}
              label={item.label}
              {...a11yProps(item.index)}
            />
          ))}
      </StyledTabs>
    </Box>
  );
};

CustomTabs.propTypes = {};

CustomTabs.defaultProps = {};

export default CustomTabs;
